import React from 'react';
import { RecoilRoot } from 'recoil';
import Fieldset from '@powerednow/components/fields/Fieldset';
import Toast from '@powerednow/components/toast/toast';
import { CreateExtComponent } from '@powerednow/client-shared/Components/react/React';
import CompanyWorkflowList from 'FieldServices/react/features/workflow/companyWorkflowList';
import AppointmentReminderListItemCard from 'FieldServices/react/features/workflow/ListItemCards/AppointmentReminderListItemCard';

function AppointmentReminders() {
    return (
        <RecoilRoot>
            <Fieldset
                title="Appointment reminders (SMS/Text only)"
                fields={[
                    <p>
                        You can send reminders to your customers before their appointments to remind them.
                    </p>,
                    <CompanyWorkflowList
                        workflowIdFilter="appointment-reminder"
                        addButtonTitle="Turn on"
                        ListItemCard={AppointmentReminderListItemCard}
                        editPanelVisible={false}
                    />,
                ]}
            />
            <Toast />
        </RecoilRoot>
    );
}

export default AppointmentReminders;
export const ExtAppointmentReminders = CreateExtComponent('FieldServices.view.settings.notification.AppointmentReminders.AppointmentReminders', AppointmentReminders, { alias: 'widget.ExtAppointmentReminders' });
